exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader .el-upload {\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.avatar-uploader .el-upload:hover {\n  border-color: #409eff;\n}\n.avatar-uploader-icon {\n  font-size: 28px !important;\n  color: #8c939d !important;\n  width: 178px !important;\n  height: 178px !important;\n  line-height: 178px !important;\n  text-align: center !important;\n}\n.avatar {\n  width: 178px;\n  height: 178px;\n  display: block;\n}", ""]);

// exports
